import initialState from '../../initialState';
import { CodePanelActions } from '../../constants';

const reducer = (state = initialState.CodePanel, action = {}) => {
  switch (action.type) {
    case CodePanelActions.UPDATE_CONTENT:
      return { ...state, content: action.content, updateLocalContent: action.updateLocalContent };
    case CodePanelActions.INSERT_OPERATION_CODE:
      return {
        ...state,
        insertedOperationCode: action.insertedOperationCode,
        insertLocation: action.insertLocation,
      };
    default:
      return state;
  }
};
export default reducer;
